import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import { typeIcons } from './_common/notificationTypes'
import { getTextedDateTime } from '../subscriptions/_helpers/dates'

const NotificationItem = (props) => {
  const { id, num, type, time_stamp, title, message, data, handleDeleteNotification } = props
  const theme = useTheme()

  const iconWidth = 60
  const deleteIconWidth = 60

  const dataKeys = data ? Object.keys(data) : []

  const iconStyle = {
    width: `${iconWidth}px`,
    height: `${iconWidth}px`,
    borderRadius: `${iconWidth / 2}px`,
    background: theme.palette.violetsAreBlue,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const notificationTitleStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
  }

  const notificationDateStyle = {
    color: theme.palette.vodka,
    fontSize: '16px',
    fontWeight: '400',
    fontStyle: 'italic',
  }

  const notificationDescriptionStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '400',
  }

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
    >
      <Box sx={{ width: `calc(100% - ${deleteIconWidth}px)` }}>
        <Stack
          direction='row'
          alignItems='flex-start'
          justifyContent='space-between'
          sx={{
            width: '100%',
            padding: '10px 0px',
            borderBottom: `${theme.palette.grayX11} 1px solid`,
          }}
        >
          <Box sx={iconStyle}>
            { typeIcons[type] ? typeIcons[type] : '' }
          </Box>
          <Box sx={{ width: `calc(100% - ${iconWidth + 20}px)` }}>
            <Box sx={notificationTitleStyle}>{num} {title}</Box>
            <Box sx={notificationDateStyle}>{getTextedDateTime(time_stamp + '+00:00')}</Box>
            <Box sx={notificationDescriptionStyle}>{message}</Box>
            {
              dataKeys.length > 0 &&
              <Box sx={notificationDescriptionStyle}>
                {
                  dataKeys.map((item, index) => (
                    <Box key={index}>{item}: {data[item]}</Box>
                  ))
                }
              </Box>
            }
          </Box>
        </Stack>
      </Box>
      <Box sx={{ width: `${deleteIconWidth}px` }}>
        <IconButton
          onClick={() => handleDeleteNotification(id)}
          sx={{ color: theme.palette.coralRed }}
        >
          <DeleteIcon fontSize='large' />
        </IconButton>
      </Box>
    </Stack>
  )
}

export default NotificationItem